import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

import AristaForm from './AristaFormComponent';
import { putArista } from '../../routing/routes';

const EditarArista = ({ nodos, archivos, functionesChatbot, setNotification, refreshData }) => {
	const { id, index } = useParams();
	const history = useHistory();
	const nodo = nodos.find((nodo) => nodo._id === id);
	function guardarArista(nuevaArista) {
		const temp = { ...nodo };
		temp.aristas = [...nodo.aristas.slice(0, Number(index)), nuevaArista, ...nodo.aristas.slice(Number(index) + 1)];
		delete temp._id;
		putArista(nodo._id, temp)
			.then(() => {
				history.push('/edit/' + nodo._id);
				setNotification('mArista editada correctamente!');
				setTimeout(refreshData, 1000);
			})
			.catch((error) => {
				setNotification('eOcurrió un error editando la arista!');
				console.error('Error:', error);
			});
	}

	if (nodo) {
		const arista = nodo.aristas[index];
		return (
			<AristaForm
				nodo={nodo}
				nodos={nodos}
				guardarArista={guardarArista}
				arista={arista}
				editing={true}
				archivos={archivos}
				functionesChatbot={functionesChatbot}
			/>
		);
	} else {
		return <p>Loading...</p>;
	}
};

export default EditarArista;
